import React, { useState } from "react";

import InputText from "../TextComponent/textInput";
import Button from "../../components/ButtonComponent/Button";
import Modal from "react-bootstrap/Modal";
import './popUp.css';

const Popup = ({ show, setShow, sendLinkBtn, onChange, value, validationMessage, handleClose }) => {

  return (
    <div>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        className="driverNumberPopup"
      >
        <Modal.Header>
          <Modal.Title>
            <h2>Driver Mobile</h2>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="modalPopBody">
          <InputText
            type="text"
            placeholder="Enter mobile number"
            value={value}
            onChange={onChange}
            className="w-full p-2 border rounded mb-4"
          />
            {validationMessage && (
            <div className="messageColor">{validationMessage}</div>
          )}
        </Modal.Body>
        <Modal.Footer className="ft-modal">
            <Button text="Cancel" onClick={handleClose} />
            <Button
              text="Send Link"
              onClick={sendLinkBtn}
            />
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Popup;
